import React, { Component } from 'react';
import  {RedPageComponent} from './RedPageComponent.js';
import {WidgetTemplateTg} from './WidgetTemplateTg.js';

export class CreatePageInputs extends React.Component {

    constructor(props) {
        super(props);
        this.refFileInputSmallImg = React.createRef();
        this.refFileInputBigImg = React.createRef();
    }

    
    render() {
        return (
        <div>
          
        
        
            
            
           <RedPageComponent
            bg_mobile_opacity={this.props.bg_mobile_opacity} 
            colorPickerBgMobileColorRef={this.props.colorPickerBgMobileColorRef}
            show_color_picker_bg_mobile_color={this.props.show_color_picker_bg_mobile_color}
            bg_mobile_color={this.props.bg_mobile_color}
            bg_mobile_color_hex={this.props.bg_mobile_color_hex}
           
            frame_view_type={this.props.frame_view_type}
           changeFrameView={this.props.changeFrameView}
           frame_height={this.props.frame_height}
           frame_width={this.props.frame_width}
            showColorPicker={this.props.showColorPicker}
            bg2_opacity={this.props.bg2_opacity} 
            initialContent={this.props.initialContent}
            bg2_color_hex={this.props.bg2_color_hex}
            bg1_color_hex={this.props.bg1_color_hex}
            bg1_opacity={this.props.bg1_opacity}
            btn_color_hex={this.props.btn_color_hex}
            big_img_src={this.props.big_img_src}
            small_img_src={this.props.small_img_src}
            refFirstStage={this.props.refFirstStage}
            h1_color_hex={this.props.h1_color_hex}
            h1_color={this.props.h1_color}
            h2_color_hex={this.props.h2_color_hex}
            
            logo_color_hex={this.props.logo_color_hex}
            btn_text_color_hex={this.props.btn_text_color_hex}
            setDefault={this.props.setDefault}
            colorPickerBtnColorRef={this.props.colorPickerBtnColorRef}
            show_color_picker_btn_color={this.props.show_color_picker_btn_color}
            btn_color={this.props.btn_color}
            handleChangeComplete={this.props.handleChangeComplete}
            colorPickerBg1ColorRef={this.props.colorPickerBg1ColorRef}
            show_color_picker_bg1_color={this.props.show_color_picker_bg1_color}
            bg1_color={this.props.bg1_color}
            
            colorPickerBg2ColorRef={this.props.colorPickerBg2ColorRef}
            show_color_picker_bg2_color={this.props.show_color_picker_bg2_color}
            bg2_color={this.props.bg2_color}

            colorPickerBtnTextColorRef={this.props.colorPickerBtnTextColorRef}
            show_color_picker_btn_text_color = {this.props.show_color_picker_btn_text_color}
            btn_text_color={this.props.btn_text_color}
            

            colorPickerH1ColorRef={this.props.colorPickerH1ColorRef}
            show_color_picker_h1_color={this.props.show_color_picker_h1_color}

            colorPickerH2ColorRef={this.props.colorPickerH2ColorRef}
            show_color_picker_h2_color={this.props.show_color_picker_h2_color}
            h2_color={this.props.h2_color}

            colorPickerLogoColorRef={this.props.colorPickerLogoColorRef}
            show_color_picker_logo_color={this.props.show_color_picker_logo_color}
            logo_color={this.props.logo_color} 
           
           
           
           
           
           










           
           
           
           
           
           
           
           
           
            ClearPhotoMobile={this.props.ClearPhotoMobile}
                timeout={this.props.timeout}
                updateTimeout={this.props.updateTimeout}

                setShowPreview={this.props.setShowPreview}
                doSave={this.props.doSave}
                prize={this.props.prize}
                updatePrize={this.props.updatePrize}
                
                header_text={this.props.header_text}
                updateHeader={this.props.updateHeader}

                main_text={this.props.main_text}
                updateMain={this.props.updateMain}

                btnText={this.props.btnText}
                handleInputChange_bigImg={this.props.handleInputChange_bigImg}
                handleInputChange_smallImg={this.props.handleInputChange_smallImg}
                big_img_src={this.props.big_img_src}
                small_img_src={this.props.small_img_src}/>
            
        
    </div>           
  
        )
    }
}